/**
 * URL de vídeo de exemplo até o autor colar o próprio link (evita embed vazio / 404).
 */
export const DEFAULT_PLACEHOLDER_VIDEO_URL = 'https://youtu.be/MQPtrKHv-II';

/** H5P público de exemplo (ID 707) — evita GET em /h5p/embed/ sem slug → 404 */
export const DEFAULT_PLACEHOLDER_H5P_URL = 'https://h5p.org/h5p/embed/707';

/**
 * Vimeo “raiz” ou sem ID numérico vira placeholder; iframes crus mantidos.
 */
export function getEffectiveVideoUrl(raw) {
  const s = (raw == null ? '' : String(raw)).trim();
  if (!s) return DEFAULT_PLACEHOLDER_VIDEO_URL;
  if (s.startsWith('<iframe')) return s;
  if (/^https?:\/\/(www\.)?vimeo\.com\/?$/i.test(s)) return DEFAULT_PLACEHOLDER_VIDEO_URL;
  if (s === 'https://vimeo.com/' || s === 'http://vimeo.com/') return DEFAULT_PLACEHOLDER_VIDEO_URL;
  if (/vimeo\.com/i.test(s) && !/vimeo\.com\/(\d+)/.test(s) && !/player\.vimeo\.com\/video\/\d+/.test(s)) {
    return DEFAULT_PLACEHOLDER_VIDEO_URL;
  }
  return s;
}

/** URL só com /embed/ sem ID numérico vira placeholder de demonstração. */
export function getEffectiveH5pUrl(raw) {
  const s = (raw == null ? '' : String(raw)).trim();
  if (!s) return DEFAULT_PLACEHOLDER_H5P_URL;
  if (/h5p\.org\/h5p\/embed\/?$/i.test(s)) return DEFAULT_PLACEHOLDER_H5P_URL;
  if (s.includes('/h5p/embed/') && !/\/h5p\/embed\/\d+/i.test(s)) return DEFAULT_PLACEHOLDER_H5P_URL;
  return s;
}
